import {cx} from "emotion";
import * as React from "react";

import "./unaddressed-quantity.scss";

import {cs}                 from "@Common/react/chain-services";
import {NumberInputBinding} from "@Common/react/number-input-binding";
import {Static2}            from "@Common/react/static-2";
import {InformationBadge}   from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";
import {ErrorHighlighter}   from "@Common/ui-components/light/error-highlighter";

export const UnaddressedQuantity = ({next}) => cs(

    ["domRef", (_, next) => Static2({next})],
    ["errorHighlighter", (_, next) => ErrorHighlighter({next})],
    ({domRef, errorHighlighter}) => next({
        getRows: ({state, showErrors}) => [
            {
                key: "unaddressed-quantity",
                className: "unaddressed-quantity-1is",
                color: "dark",
                columns: [
                    {},
                    {
                        colSpan: 2,
                        className: "label",
                        render: () => <>
                            <div className="line1">
                                <div className="text" xd-qa-type="label" xd-qa-name="Unaddressed Quantity">
                                    Unaddressed Quantity
                                </div>
                            </div>
                        </>,
                    },
                    {
                        className: cx("count"),
                        ref: domRef.set,
                        render: () => cs(
                            ["binding", (_, next) => NumberInputBinding({
                                state,
                                isValid: (v) => v >= 0,
                                defaultValue: 0,
                                next,
                            })],
                            ({binding}) => (
                                <input xd-qa-type="text_field" xd-qa-name="Unaddressed Quantity"{...{
                                    ...binding,
                                }}/>
                            )
                        ),
                    },
                ],
            }
        ],
    }),
);